/* CRWNZ · ORIGIN 001 — card color swatches.
   Picking a swatch only updates what the card shows (image, selected color,
   size availability) and which real variant its links open. No cart or
   product writes happen here; add-to-cart stays on Shopify's product form. */
(function () {
  if (window.customElements && customElements.get('crwnz-swatches')) return;

  class CrwnzSwatches extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.card = this.closest('[data-crwnz-card]');
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-crwnz-swatch]');
        if (!btn || !this.contains(btn)) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(btn, true);
      });
      this.addEventListener('keydown', (event) => {
        const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
        if (!keys.includes(event.key)) return;
        const btns = Array.from(this.querySelectorAll('[data-crwnz-swatch]'));
        const i = btns.indexOf(document.activeElement);
        if (i < 0) return;
        event.preventDefault();
        const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        const next = btns[(i + step + btns.length) % btns.length];
        this.select(next, true);
        next.focus();
      });
    }

    select(btn, userPicked) {
      this.querySelectorAll('[data-crwnz-swatch]').forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });

      const label = this.querySelector('[data-crwnz-selected-color]');
      if (label) label.textContent = btn.dataset.colorName || '';

      const key = btn.dataset.sizesKey;
      this.querySelectorAll('[data-crwnz-sizes]').forEach((list) => {
        list.hidden = list.dataset.crwnzSizes !== key;
      });

      const card = this.card;
      if (!card) return;

      const url = btn.dataset.variantUrl;
      if (url) {
        card.querySelectorAll('[data-crwnz-card-link]').forEach((a) => {
          if (!a.classList.contains('crwnz-swatch-more')) a.setAttribute('href', url);
        });
        // Dawn quick add opens the real product form; point it at this variant.
        card.querySelectorAll('[data-product-url]').forEach((el) => {
          el.dataset.productUrl = url;
        });
      }

      const priceEl = card.querySelector('[data-crwnz-card-price]');
      if (priceEl && btn.dataset.priceHtml) priceEl.innerHTML = btn.dataset.priceHtml;

      card.classList.toggle('is-cutout', btn.dataset.cutout === '1');

      const src = btn.dataset.imageSrc;
      const img = card.querySelector('[data-crwnz-card-image]');
      if (src && img) {
        if (btn.dataset.imageSrcset) img.setAttribute('srcset', btn.dataset.imageSrcset.trim());
        img.setAttribute('src', src);
        if (btn.dataset.imageAlt) img.setAttribute('alt', btn.dataset.imageAlt);
        img.removeAttribute('loading');
        if (userPicked) card.classList.add('crwnz-color-picked');
      }
    }
  }

  if (window.customElements) customElements.define('crwnz-swatches', CrwnzSwatches);
})();

/* ORIGIN 001 hero — subtle pointer parallax on the floating products.
   Desktop pointers only; off for reduced motion and CRWNZ performance mode. */
(function () {
  function initHero(hero) {
    if (!hero || hero.dataset.o1Bound) return;
    hero.dataset.o1Bound = '1';
    const stage = hero.querySelector('[data-o1-stage]');
    if (!stage) return;
    // Entrance plays once; afterwards the pieces are locked in place and only float.
    const items = stage.querySelectorAll('.o1h-item');
    let landed = 0;
    const land = () => hero.classList.add('is-landed');
    items.forEach((el) => el.addEventListener('animationend', (e) => {
      if (e.animationName === 'o1hIn' && ++landed >= items.length) land();
    }));
    setTimeout(land, 1400);
    decode(hero);
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduced) return;
    let raf = 0, x = 0, y = 0;
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      x = ((e.clientX - r.left) / r.width - 0.5) * 2;
      y = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(() => {
        raf = 0;
        stage.style.setProperty('--px', x.toFixed(3));
        stage.style.setProperty('--py', y.toFixed(3));
      });
    });
    hero.addEventListener('pointerleave', () => {
      stage.style.setProperty('--px', 0);
      stage.style.setProperty('--py', 0);
    });
  }
  // One-time "decode" of the drop code: random glyphs resolve left to right (~0.7s)
  function decode(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('[data-o1-decode]').forEach((el, idx) => {
      const final = el.textContent;
      const digits = el.dataset.o1Decode === 'digits';
      const pool = digits ? '0123456789' : 'ABCDEFGHJKMNPQRSTUVWXYZ0123456789/_#<>';
      const total = 16 + idx * 4;
      let f = 0;
      el.style.minWidth = el.offsetWidth ? el.offsetWidth + 'px' : '';
      const tick = () => {
        f++;
        const solved = Math.floor((f / total) * final.length);
        el.textContent = final.split('').map((c, i) => (i < solved || c === ' ' || c === '/' ) ? c : pool[(Math.random() * pool.length) | 0]).join('');
        if (f < total) setTimeout(tick, 42); else el.textContent = final;
      };
      setTimeout(tick, 180 + idx * 120);
    });
  }
  function boot(scope) {
    (scope || document).querySelectorAll('[data-o1-hero]').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

/* PDP: instant color switching between same-title products (each color is its own
   Shopify product). Swaps the product section in place — no full page reload —
   using the same HTMLUpdateUtility Dawn uses for its own variant/product swaps.
   Hovering/focusing a swatch prefetches it so the click is effectively instant. */
(function () {
  const SEL = '.crwnz-swatches--pdp a.crwnz-swatch';
  const cache = new Map();
  const sectionUrl = (a, pi) => {
    const u = new URL(a.href, location.origin);
    u.searchParams.set('section_id', pi.dataset.section);
    return u.toString();
  };
  const load = (url) => {
    if (!cache.has(url)) {
      cache.set(url, fetch(url).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }));
      cache.get(url).catch(() => cache.delete(url));
    }
    return cache.get(url);
  };
  const prefetch = (e) => {
    const a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    const pi = a.closest('product-info');
    if (!pi || !pi.dataset.section) return;
    load(sectionUrl(a, pi)).catch(() => {});
    if (a.dataset.imageSrc && !a._pre) { a._pre = new Image(); a._pre.src = a.dataset.imageSrc; }
  };
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
  document.addEventListener('touchstart', prefetch, { passive: true });

  document.addEventListener('click', async (e) => {
    const a = e.target.closest && e.target.closest(SEL);
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    const pi = a.closest('product-info');
    if (!pi || !pi.dataset.section) return;
    e.preventDefault();
    if (a.classList.contains('is-selected')) return;

    // Immediate feedback before the swap lands
    a.parentElement.querySelectorAll('.crwnz-swatch').forEach((x) => x.classList.toggle('is-selected', x === a));
    const label = pi.querySelector('[data-crwnz-selected-color]');
    const prevColor = label ? label.textContent.trim() : '';
    if (label) label.textContent = a.dataset.colorName || '';
    if (prevColor && a.dataset.colorName && document.title.includes(prevColor)) document.title = document.title.replace(prevColor, a.dataset.colorName);
    const firstImg = pi.querySelector('.product__media-list .product__media img');
    if (firstImg && a.dataset.imageSrc) { firstImg.removeAttribute('srcset'); firstImg.src = a.dataset.imageSrc; }
    pi.classList.add('crwnz-swapping');

    try {
      const html = await load(sectionUrl(a, pi));
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('product-info');
      if (!next) throw new Error('no product-info');
      const y = window.scrollY;
      // Dawn moves the zoom modal to <body>; drop the old product's one so zoom
      // never opens the previous colour's images.
      document.querySelectorAll(`product-modal[id="ProductModal-${pi.dataset.section}"]`).forEach((m) => m.remove());
      if (window.HTMLUpdateUtility) {
        HTMLUpdateUtility.viewTransition(pi, next, [], [() => { window.Shopify?.PaymentButton?.init(); }]);
      } else {
        pi.replaceWith(next);
      }
      window.scrollTo(0, y);
      if (pi.dataset.updateUrl !== 'false') history.pushState({ crwnzSwap: true }, '', a.href);
    } catch (err) {
      location.href = a.href;
    }
  });

  window.addEventListener('popstate', () => {
    if (document.querySelector('.crwnz-swatches--pdp')) location.reload();
  });
})();

/* Shop page category tabs: show/hide grid items by category, no reload */
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('[data-crwnz-cats] .crwnz-cat');
  if (!btn) return;
  const wrap = btn.closest('[data-crwnz-cats]');
  const cat = btn.dataset.cat;
  wrap.querySelectorAll('.crwnz-cat').forEach((b) => { const on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
  const grid = wrap.parentElement.querySelector('#product-grid');
  if (grid) grid.querySelectorAll(':scope > li[data-crwnz-cat]').forEach((li) => { li.hidden = cat !== 'all' && li.dataset.crwnzCat !== cat; });
});

/* Shop page: group the "All" view by category (unless the shopper chose a sort) */
(function () {
  const ORDER = ['hoodies', 'tees', 'mousepads', 'accessories'];
  function arrange(root) {
    if (new URLSearchParams(location.search).has('sort_by')) return;
    const grid = (root || document).querySelector('#product-grid');
    if (!grid || !grid.parentElement.querySelector('[data-crwnz-cats]')) return;
    const items = Array.from(grid.querySelectorAll(':scope > li[data-crwnz-cat]'));
    items
      .map((li, i) => ({ li, i, r: ORDER.indexOf(li.dataset.crwnzCat) }))
      .sort((a, b) => (a.r - b.r) || (a.i - b.i))
      .forEach(({ li }) => grid.appendChild(li));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => arrange());
  else arrange();
  // Dawn re-renders the grid after filtering
  new MutationObserver(() => { const g = document.querySelector('#product-grid'); if (g && !g.dataset.crwnzArranged) { g.dataset.crwnzArranged = '1'; arrange(); } })
    .observe(document.body, { childList: true, subtree: true });
})();

/* Clip of the Week: click-to-play embeds. Only known platforms are embedded and
   the iframe URL is always built from a parsed ID, never from raw input. */
(function () {
  function embedFor(raw) {
    let u;
    try { u = new URL(raw); } catch (e) { return null; }
    if (u.protocol !== 'https:') return null;
    const host = u.hostname.replace(/^www\.|^m\./, '');
    const parts = u.pathname.split('/').filter(Boolean);
    const clean = (s) => (s || '').replace(/[^A-Za-z0-9_-]/g, '');
    const parent = location.hostname;
    if (host === 'clips.twitch.tv' && parts[0]) return `https://clips.twitch.tv/embed?clip=${clean(parts[0])}&parent=${parent}&autoplay=true`;
    if (host === 'twitch.tv') {
      const i = parts.indexOf('clip');
      if (i > -1 && parts[i + 1]) return `https://clips.twitch.tv/embed?clip=${clean(parts[i + 1])}&parent=${parent}&autoplay=true`;
      if (parts[0] === 'videos' && parts[1]) return `https://player.twitch.tv/?video=${clean(parts[1])}&parent=${parent}&autoplay=true`;
    }
    if (host === 'youtu.be' && parts[0]) return `https://www.youtube-nocookie.com/embed/${clean(parts[0])}?autoplay=1&rel=0`;
    if (host === 'youtube.com') {
      const id = parts[0] === 'shorts' || parts[0] === 'live' ? parts[1] : u.searchParams.get('v');
      if (id) return `https://www.youtube-nocookie.com/embed/${clean(id)}?autoplay=1&rel=0`;
    }
    if (host === 'tiktok.com') {
      const i = parts.indexOf('video');
      if (i > -1 && parts[i + 1]) return `https://www.tiktok.com/embed/v2/${clean(parts[i + 1])}`;
    }
    if (host === 'streamable.com' && parts[0]) return `https://streamable.com/e/${clean(parts[parts[0] === 'e' ? 1 : 0])}?autoplay=1`;
    if (host === 'medal.tv') {
      const i = parts.indexOf('clips');
      if (i > -1 && parts[i + 1]) return `https://medal.tv/clip/${clean(parts[i + 1])}?autoplay=1&muted=0&cta=0`;
    }
    return null;
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-clip-player] .clip-player__poster');
    if (!btn) return;
    const wrap = btn.closest('[data-clip-player]');
    const src = embedFor(wrap.dataset.url);
    if (!src) { window.open(wrap.dataset.url, '_blank', 'noopener'); return; }
    const f = document.createElement('iframe');
    f.src = src;
    f.title = btn.getAttribute('aria-label') || 'Clip';
    f.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    f.allowFullscreen = true;
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    f.loading = 'eager';
    wrap.classList.add('is-playing');
    btn.replaceWith(f);
  });
})();

/* PDP hover zoom (desktop): the image itself scales up in place, zooming
   toward the point under the cursor, and follows the mouse. Click still opens
   the lightbox for that same image. Delegated, so it survives colour swaps. */
(function () {
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const ZOOM = 1.9;
  let active = null;
  function end() {
    if (!active) return;
    const { box, img } = active;
    box.classList.remove('is-zooming');
    img.style.transform = '';
    active = null;
  }
  document.addEventListener('pointermove', (e) => {
    if (!fine.matches) return;
    const box = e.target.closest && e.target.closest('product-info .product__media-list .product-media-container');
    if (!box) { end(); return; }
    const img = box.querySelector('.product__media img');
    if (!img) return;
    if (!active || active.box !== box) { end(); active = { box, img }; box.classList.add('is-zooming'); }
    const r = box.getBoundingClientRect();
    const x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1) * 100;
    const y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = `scale(${ZOOM})`;
  }, { passive: true });
  document.documentElement.addEventListener('pointerleave', end);
  window.addEventListener('scroll', end, { passive: true });
})();
